import {FC, ReactNode} from "react";
import {useTranslation} from "react-i18next";
import {CarSolidIcon} from "@interstate/components/Icons/CarSolidIcon";
import {HomeIcon} from "@interstate/components/Icons/HomeIcon";

import {useOperationalEntity} from "../../context";
import {DealerStatusBarItem} from "../../overview";
import "../../overview/DetailsColumnHeader.scss";
import {Flag} from "@interstate/components/Flag";
import {LockClosedIcon} from "@interstate/components/Icons";
import {
  EntityStatus,
  EntityType,
  entityTypeKey
} from "@common-core/coat-operational-hierarchy-appsync-model";

export const OperationalDetailsHeader: FC = () => {
  const {t} = useTranslation();
  const {
    entity: {id, entityType, statuses}
  } = useOperationalEntity();

  const dealerTypeItem = (): ReactNode => {
    switch (entityType) {
      case EntityType.GROUP:
      case EntityType.SUB_GROUP:
        return (
          <DealerStatusBarItem
            type={"dealer-type"}
            value={entityTypeKey(entityType)}
            icon={HomeIcon}
            label={t(`entity-detail.types.${entityTypeKey(entityType)}`)}
          />
        );
      case EntityType.STANDALONE_ENTITY:
      case EntityType.ENTITY:
        return (
          <DealerStatusBarItem
            type={"dealer-type"}
            value={entityTypeKey(entityType)}
            icon={CarSolidIcon}
            label={t(`entity-detail.types.${entityTypeKey(entityType)}`)}
          />
        );
    }
  };

  return (
    <header
      id={`operational-details-header-${id}`}
      data-testid={`operational-details-header-${id}`}
      className={"details-column-header"}>
      <hgroup className={"details-column-header-group"}>
        <h3>{t("entity-detail.dealer.details")}</h3>
        {statuses?.includes(EntityStatus.PROTECTED) && (
          <aside className={"entity-card-header-callout"}>
            <Flag
              id={id}
              data-testid={id}
              variant={"info"}
              startIcon={<LockClosedIcon />}>
              Protected
            </Flag>
          </aside>
        )}
      </hgroup>
      {dealerTypeItem()}
    </header>
  );
};
